<template>
  <div class="contact" data-model-id="3:4242">
    <NavSubsection />
    <HeroSubsection />
    <ContactFormSubsection />
    <InfoCardsSubsection />
    <MapSubsection />
    <FooterSubsection />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavSubsection from "./Contact/sections/NavSubsection.vue";
import HeroSubsection from "./Contact/sections/HeroSubsection.vue";
import ContactFormSubsection from "./Contact/sections/ContactFormSubsection.vue";
import InfoCardsSubsection from "./Contact/sections/InfoCardsSubsection.vue";
import MapSubsection from "./Contact/sections/MapSubsection.vue";
import FooterSubsection from "./Contact/sections/FooterSubsection.vue";

export default defineComponent({
  name: "Contact",
  components: {
    NavSubsection,
    HeroSubsection,
    ContactFormSubsection,
    InfoCardsSubsection,
    MapSubsection,
    FooterSubsection,
  },
});
</script>

<style>
.contact {
  align-items: center;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
}

@media (max-width: 1024px) {
  .contact :is(
      .hero-subsection,
      .contact-form-subsection,
      .info-cards-subsection,
      .map-subsection
    ) {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .contact .cards-grid {
    display: flex !important;
    flex-direction: column !important;
    gap: 16px !important;
  }

  .contact :is(.info-card, .form-container, .map-container) {
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }

  .contact .form-row {
    flex-direction: column !important;
    gap: 16px !important;
  }

  .contact .form-row .form-group {
    min-width: 0 !important;
  }
}

@media (max-width: 768px) {
  .contact :is(
      .hero-subsection,
      .contact-form-subsection,
      .info-cards-subsection,
      .map-subsection
    ) {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}
</style>
